module.exports = __webpack_public_path__ + "static/img/8c1ea45be97d5771d9d89e912b19dd04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/workflow_disable_03.png
// module id = bV6o
// module chunks = 1